import React, { useEffect, useRef, useState } from 'react'
import { IRiskProfile } from '../../../../../services/FundService'

const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

interface IProps {
  value: number | null
  profiles: IRiskProfile[]
  onChange: (id: number) => void
}

export const ProfileSelect: React.FC<IProps> = ({ value, profiles, onChange }) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const selected = profiles.find((p) => p.id === value) ?? null

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type='button'
        onClick={() => setOpen((o) => !o)}
        style={{
          background: selected ? hexToRgba(selected.color, 0.12) : '#F9FAFB',
          border: `1px solid ${selected ? hexToRgba(selected.color, 0.35) : '#D1D5DB'}`,
          borderRadius: 20,
          color: selected ? selected.color : '#9CA3AF',
          fontWeight: 600,
          fontSize: 13,
          padding: '4px 10px 4px 12px',
          cursor: 'pointer',
          outline: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          minWidth: 130,
        }}
      >
        <span style={{ flex: 1, textAlign: 'left' }}>{selected?.name ?? '—'}</span>
        <i className='bi bi-chevron-down' style={{ fontSize: 11 }} />
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            background: '#fff',
            border: '1px solid #E5E7EB',
            borderRadius: 8,
            boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
            zIndex: 200,
            minWidth: 160,
            padding: 6,
          }}
        >
          {profiles.map((p) => (
            <button
              key={p.id}
              type='button'
              onClick={() => {
                onChange(p.id)
                setOpen(false)
              }}
              style={{
                display: 'block',
                width: '100%',
                background: hexToRgba(p.color, 0.12),
                border: `1px solid ${hexToRgba(p.color, 0.3)}`,
                borderRadius: 6,
                color: p.color,
                fontWeight: 600,
                fontSize: 13,
                padding: '7px 12px',
                cursor: 'pointer',
                textAlign: 'left',
                marginBottom: 4,
              }}
            >
              {p.name}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
